import { render, staticRenderFns } from "./TabDescription.vue?vue&type=template&id=b6c690fc"
import script from "./TabDescription.vue?vue&type=script&lang=js"
export * from "./TabDescription.vue?vue&type=script&lang=js"
import style0 from "./TabDescription.vue?vue&type=style&index=0&id=b6c690fc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports